const es = {
  state: {
    expression_1: 'Avatar',
    expression_2: 'Campaña',
    expression_3: 'Campañas',
    expression_4: 'Canal',
    expression_5: 'Canales',
    expression_6: 'Elige un canal',
    expression_7: 'Elige un canal ...',
    expression_8: 'Elija un canal para ver el gráfico.',
    expression_9: 'Seleccione una opción...',
    expression_10: 'Limpiar notificaciones',
    expression_11: 'Indicadores',
    expression_12: 'Equipo',
    expression_13: 'Equipos',
    expression_14: 'Descargar gráfico',
    expression_15: 'Duración',
    expression_16: 'Compromiso',
    expression_17: 'Cerrado por',
    expression_18: 'Cerrado en',
    expression_19: 'Cerrado (hoy)',
    expression_20: 'Protocolos terminados hoy',
    expression_21: 'Cerrado',
    expression_22: 'Cerrado esta semana',
    expression_23: 'Embudo',
    expression_24: 'opcional',
    expression_25: 'Embudos',
    expression_26: 'Las reglas comerciales a continuación solo están disponibles para los clientes del plan BEECRM. ¡Ponte en contacto con nuestro equipo comercial y contrata ya!',
    expression_27: 'Aprende a activar',
    expression_28: 'id',
    expression_29: 'En servicio',
    expression_30: 'Protocolos en servicio',
    expression_31: 'Interes',
    expression_32: 'Intereses',
    expression_33: 'Últimas conversaciones',
    expression_34: 'Contact',
    expression_35: 'Contacts',
    expression_36: 'Cargando...',
    expression_37: 'Salir',
    expression_38: 'Chat',
    expression_39: 'Negociaciones perdidas este mes',
    expression_40: 'Mi perfil',
    expression_41: 'Perfil',
    expression_42: 'Nombre',
    expression_43: 'Sin metas existentes.',
    expression_44: 'No se encontró ningún protocolo.',
    expression_45: 'Notificación',
    expression_46: 'Notificaciones',
    expression_47: 'Calificaciones',
    expression_48: 'Agente',
    expression_49: 'Agentes',
    expression_50: 'Operadores',
    expression_51: 'Operadores',
    expression_52: 'Dashboard',
    expression_53: 'Rendimiento',
    expression_54: 'Contacto',
    expression_55: 'Protocolo',
    expression_56: 'Calificación',
    expression_57: 'Calificaciones',
    expression_58: 'Informe',
    expression_59: 'Informes',
    expression_60: 'Buscar',
    expression_61: 'segundos',
    expression_62: 'Configuraciones',
    expression_63: 'Ver más',
    expression_64: 'Ver reportes',
    expression_65: 'Apellido',
    expression_66: 'Inició en',
    expression_67: 'Estado',
    expression_68: 'Tarea',
    expression_69: 'Tareas',
    expression_70: 'Es portugués!',
    expression_71: 'este mes',
    expression_72: 'Protocolo',
    expression_73: 'Conversaciones',
    expression_74: 'Conéctese a la API oficial de WhatsApp',
    expression_75: 'TMS',
    expression_76: 'Tiempo medio de servicio',
    expression_77: 'TMB',
    expression_78: 'Tiempo medio en chat-bot',
    expression_79: 'TME',
    expression_80: 'Tiempo medio de espera',
    expression_81: 'Agente',
    expression_82: 'Usuarios',
    expression_83: 'Esperando',
    expression_84: 'Protocolos esperando servicio',
    expression_85: 'Organization',
    expression_86: 'Negociaciones ganadas este mes',
    expression_87: 'En negociación',
    expression_88: 'Ganado',
    expression_89: 'Perdido',
    expression_90: 'Promedio',
    expression_91: 'Los resultados de su búsqueda se mostrarán a continuación.',
    expression_92: 'Informaciónes del contacto',
    expression_93: 'Detalles',
    expression_94: 'Administrar usuarios del sistema',
    expression_95: 'Detalles del usuario',
    expression_96: 'Editar las configuración del usuario',
    expression_97: 'Registra y gestiona tus canales de comunicación',
    expression_98: 'Edita las configuraciones de tu canal',
    expression_99: 'Campañas',
    expression_100: 'Crear campaña',
    expression_101: 'Editar las configuraciones de la publicación',
    expression_102: 'Direcciones',
    expression_103: 'Informe de participación',
    expression_104: 'URL\'s',
    expression_105: 'Informe de Desempeño',
    expression_106: 'Informe del Conversaciones',
    expression_107: 'Empieza a registrar o gestionar tus tareas',
    expression_108: 'Muestra el nombre del operador en los mensajes enviados.',
    expression_109: 'Importar leads',
    expression_110: 'Insertar contacto',
    expression_111: 'Identifica al agente',
    expression_112: 'Exportar leads',
    expression_113: 'Regresar',
    expression_114: 'Buscar usuario',
    expression_115: 'Registrar usuario',
    expression_116: 'registros encontrados',
    expression_117: 'registro encontrado',
    expression_118: 'Registrar canal',
    expression_119: 'Buscar un canal',
    expression_120: 'Guardar',
    expression_121: 'Límite de 31 días',
    expression_122: 'Exportar Excel',
    expression_123: 'Todos los canales',
    expression_124: 'Elija un departamento ...',
    expression_125: 'Elija un departamento',
    expression_126: 'Elija un asistente',
    expression_127: 'Todos los asistentes',
    expression_128: 'Buscar leads',
    expression_129: 'Buscar Conversaciones',
    expression_130: 'Exportar PDF',
    expression_131: 'Para ver registros, realice una búsqueda',
    expression_132: 'Actualizado en',
    expression_133: 'Para ver los resultados, seleccione un canal',
    expression_134: 'Ayuda',
    expression_135: 'Agregar nueva tarea',
    expression_136: 'Contacts',
    expression_137: 'Verificados',
    expression_138: 'Verificado',
    expression_139: 'No tienen cuenta',
    expression_140: 'No tiene cuenta',
    expression_141: 'No Verificados',
    expression_142: 'No Verificado',

    expression_143: 'No hay correo electrónico registrado',
    expression_144: 'Fecha de cancelación de registro',
    expression_145: 'Evaluación',
    expression_146: 'Sin tag vinculado',
    expression_147: 'Arrastra las opciones hacia un lado',
    expression_148: 'Ningún contacto encontrado',
    expression_149: 'Anotaciones',
    expression_150: 'Tags',
    expression_151: 'Tag',
    expression_152: 'Billetera',
    expression_153: 'Billeteras',
    expression_154: 'Sexo femenino',
    expression_155: 'Sexo masculino',
    expression_156: 'Fecha de suscripción',
    expression_157: 'Iniciar Conversación',
    expression_158: 'Negociación',
    expression_159: 'Fecha de suscripción',
    expression_160: 'Newsletter',
    expression_161: 'E-mail',
    expression_162: 'E-mail no registrado',
    expression_163: 'Cancelación de registro en ',
    expression_164: 'Suscripción en ',
    expression_165: 'Evaluación (NES)',
    expression_166: 'Informaciones',
    expression_167: 'Modificar',
    expression_168: 'Documento',
    expression_169: 'No registrado',
    expression_170: 'No informado',
    expression_171: 'No registrado',
    expression_172: 'No informada',
    expression_173: 'Perfil de trabajo',
    expression_174: 'Posición',
    expression_175: 'nombre de la calle',
    expression_176: 'CP',
    expression_177: 'Ciudad',
    expression_178: 'Número',
    expression_179: 'Barrio',
    expression_180: 'Estado',
    expression_181: 'Referencia',
    expression_182: 'País',
    expression_183: 'Tipo de nota',
    expression_184: 'Crea una anotación',
    expression_185: 'Escribe algo...',
    expression_186: 'Ninguna anotación se ha creada.',
    expression_187: 'Tags disponibles',
    expression_188: 'Haga clic en el nombre de la tag para vincular',
    expression_189: 'Sin tag vinculada.',
    expression_190: 'Descargar archivo',
    expression_191: 'Operador',
    expression_192: 'NES',
    expression_193: 'N° del Protocolo',
    expression_194: 'Vendido!',
    expression_195: 'No vendido',
    expression_196: 'Ninguno protocolo fue registrado.',
    expression_197: 'Vincular atendente',
    expression_198: 'Acción',
    expression_199: 'Transferir Contact',
    expression_200: 'Eliminar',
    expression_201: 'No hay asistentes vinculados a este lead',
    expression_202: 'Elija un canal y un departamento para ver los tableros.',
    expression_203: 'Documentos',
    expression_204: 'Ya has alcanzado el límite de usuarios en este canal!',
    expression_205: 'En Proceso',
    expression_206: 'Cerrados',
    expression_207: 'Generar un código QR',
    expression_208: 'Hola: :operator_name, ¿estás ahí?',
    expression_209: 'Si no confirma, ¡se desconectará en 5 minutos!',
    expression_210: '¡Si estoy aqui!',
    expression_211: 'Al hacer clic en Continuar, aceptas las',
    expression_212: 'Metatérminos para Whatsapp Business',
    expression_213: 'Error al verificar el número',
    expression_214: 'Comuníquese con el soporte e informe el <strong>Código de error: 1001</strong>',
    expression_215: 'total',
    expression_216: 'enviado',
    expression_217: 'El teléfono no tiene whatsapp',
    expression_218: 'No es posible agregar ni abrir un ticket con este teléfono ya que no tiene una cuenta de Whatsapp',
    expression_219: 'Mensajes enviados',
    expression_220: 'Mensajes recibidos',
    expression_221: 'Inbox',
    expression_222: 'Contraseña',
    expression_223: 'Mostrar contraseña',
    expression_224: 'Ocultar contraseña',
    expression_225: 'Crear nueva contraseña',
    expression_226: 'Olvide clave de acceso',
    expression_227: 'Entrar',
    expression_228: 'Correo electrónico verificado correctamente!',
    expression_229: 'Ir al dashboard',
    expression_230: 'Enlace inválido',
    expression_231: 'Parece que el enlace al que intenta acceder ya no está disponible.',
    expression_232: 'Volver al inicio',
    expression_233: 'Busque un nombre o un número de teléfono.',
    expression_234: 'Indisponible',
    expression_235: 'Último visto',
    expression_236: 'Canal Bloqueado',
    expression_237: 'Canal En Línea',
    expression_238: 'Canal Sin Conexión',
    expression_239: 'Ninguno canal se ha registrado hasta agora.',
    expression_240: 'Guardar alteraciones',
    expression_241: 'Parâmetros',
    expression_242: 'Horario de atención',
    expression_243: 'Calificación del Protocolo',
    expression_244: 'Respuestas Rápidas',
    expression_245: '¡Tu campaña estará funcionando en poco tiempo!',
    expression_246: 'Autoservicio',
    expression_247: 'Ativación',
    expression_248: 'Integraciones',
    expression_249: 'Widget de Sitio Web',
    expression_250: 'Plantilla HSM',
    expression_251: 'Planos y adicionales',
    expression_252: 'Ha alcanzado el límite de algunos recursos.',
    expression_253: 'Total de campañas',
    expression_254: 'Campañas completadas',
    expression_255: 'Campañas programadas',
    expression_256: 'Campañas en proceso',
    expression_257: 'Tipo de las campañas',
    expression_258: 'Lista de transmisión',
    expression_259: 'Fecha de creación',
    expression_260: 'Fecha del envío',
    expression_261: 'Prévio del texto',
    expression_262: 'Cerrado',
    expression_263: 'Midia',
    expression_264: 'Texto',
    expression_265: 'Métricas de envio',
    expression_266: 'Métricas',
    expression_267: 'lista(s) completa(s)',
    expression_268: 'Público objetivo',
    expression_269: 'Todos los leads válidos',
    expression_270: 'Ninguna campaña fue creada hasta el momento',
    expression_271: 'Orientaciones',
    expression_272: 'Para continuar con la creación de su campaña, debe aceptar los siguientes términos:',
    expression_273: 'Por su seguridad, nunca ejecute dos o más campañas simultáneamente. Esto puede resultar en un exilio permanente de su número.',
    expression_274: 'Solo haz clic en "Guardar publicación" si estás seguro de que todas las configuraciones son correctas.',
    expression_275: 'Las mensajes que utilicen una lista de transmisión solo se reenviarán a los usuarios que agreguen su número de teléfono a su directorio telefónico y se hayan comunicado al menos una vez por WhatsApp dentro del sistema.',
    expression_276: 'En la medida de lo posible, evite importar listas de contactos que nunca se han comunicado con el sistema y que no tienen su número guardado en la agenda. WhatsApp valida las listas y puede que no las envíe si detecta que sus miembros nunca se han comunicado o que su contacto no está guardado. Esto puede afectar a quienes cumplen con las reglas.',
    expression_277: 'El tiempo de envío se vuelve muy importante para que el lead no rechace sus transmisiones. El horario adecuado para enviar una transmisión masiva es entre las 8:00 am y las 6:00 pm.',
    expression_278: 'Tenga en cuenta que el uso frecuente de transmisiones masivas puede llevar a leads a reportar sus mensajes como SPAM.',
    expression_279: 'Continuar',
    expression_280: 'Publicar en',
    expression_281: 'Seleccionar todo',
    expression_282: 'Ninguno canal disponible para la campaña.',
    expression_283: 'Tipo de campaña',
    expression_284: 'Elija su tipo de campaña: Lista de transmisión o Estado',
    expression_285: 'Elija una opción...',
    expression_286: 'Todos los leads',
    expression_287: 'Enviar para tags',
    expression_288: 'Contenido de la toma',
    expression_289: 'Escribe el contenido de la campaña. Puede adjuntar medios o programar el envío de la publicación.',
    expression_290: "Método de envío",
    expression_291: 'Programe lo que se enviará automáticamente cuando el lead envíe un mensaje.',
    expression_292: 'Envío inmediato',
    expression_293: 'Envío programado',
    expression_294: 'Si elige esta opción, el mensaje de presentación será reemplazado por el medio que envíe aquí.',
    expression_295: 'Mensaje de apresentación (bienvenida)',
    expression_296: 'Añade uno más',
    expression_297: 'Quitar medio',
    expression_298: 'agregar emoji',
    expression_299: 'Las campañas de estado que solo contengan texto tendrán colores de fondo aleatorios. Los colores que se muestran aquí no son meramente ilustrativos.',
    expression_300: "Vista previa del mensaje",
    expression_301: 'Su mensaje aparecerá aquí...',
    expression_302: 'Mi estado',
    expression_303: 'Generar campaña',
    expression_304: 'Indique qué contactos deben recibir la campaña.',
    expression_305: 'Llamada en progreso...',
    expression_306: 'Llamando...',
    expression_307: 'Finalizar llamada',
    expression_308: 'Activar el sonido',
    expression_309: 'Desactivar el sonido',
    expression_310: 'Quieres eliminar todas las notificaciones?',
    expression_311: 'Esta acción es irreversible.',
    expression_312: 'Servicio',
    expression_313: 'Al pausar la campaña podrás reanudarla más tarde.',
    expression_314: 'Total de Protocolos',
    expression_315: 'Protocolos Esperando',
    expression_316: 'Protocolos Cerrados',
    expression_317: 'Cerrados',
    expression_318: 'Protocolos Rechazado',
    expression_319: 'Rechazados',
    expression_320: 'Métricas diarias (este mes)',
    expression_321: 'Seleccione un canal para ver el reporte.',
    expression_322: 'Ninguna origen se ha registrada en este canal',
    expression_323: 'Total de canales que tenían leads únicos',
    expression_324: 'Total de departamentos que tenían leads únicos',
    expression_325: 'Total de atendentes',
    expression_326: 'Total de leads únicos este mes',
    expression_327: 'Contacts (este mes)',
    expression_328: 'Total de leads únicos en el último mes',
    expression_329: 'Contacts (mes pasado)',
    expression_330: 'Nombre del Canal',
    expression_331: 'No encontramos ningún dato para este filtro.',
    expression_332: 'Elija un canal, departamento y / o agente para ver el informe detallado.',
    expression_333: 'Contactos registrados (mes)',
    expression_334: 'TOTAL',
    expression_335: 'Ninguno servicio se ha realizado hasta el momento.',
    expression_336: 'Agregar submenú',
    expression_337: 'Opción oculta',
    expression_338: 'Opción visible',
    expression_339: 'Eliminiar opción',
    expression_340: 'Cerrar',
    expression_341: 'Opción',
    expression_342: 'Ingrese el número correspondiente a esta opción.',
    expression_343: 'Subtitular',
    expression_344: 'Ingrese el título o pie de foto para esta opción.',
    expression_345: 'Palabras clave',
    expression_346: 'Utilice el campo a continuación para que el lead pueda identificar el menú con palabras clave, siempre sepárelas con una coma.',
    expression_347: 'Ej: "recibir ofertas, si quiero recibir"',
    expression_348: 'Mensaje (texto y / o medios)',
    expression_349: 'Escriba un mensaje o adjunte un medio para enviarlo al Contact.',
    expression_350: 'Elija la TAG a la que el leads se vinculará automáticamente.',
    expression_351: 'Defina si los Contacts se suscribirán automáticamente al Newsletter.', ///////
    expression_352: 'Ninguna opción creada.',
    expression_353: 'De verdad quieres realizar esta acción?',
    expression_354: 'Si, proceda',
    expression_355: 'Cancelar',
    expression_356: 'Configuración de la organización',
    expression_357: 'Haga clic para bloquear el canal',
    expression_358: 'Bloquear',
    expression_359: 'Haga clic para desbloquear el canal',
    expression_360: 'Desbloquear',
    expression_361: 'Limpiar mensajes',
    expression_362: 'Haga clic para borrar los mensajes de la cola de envío',
    expression_363: 'Departamento',
    expression_364: 'Nombre',
    expression_365: 'Complemento / Referencia',
    expression_366: 'Reglas del Negocio',
    expression_367: 'Atendimento Humano',
    expression_368: 'API',
    expression_369: 'Campaña',
    expression_370: 'Registro contacto',
    expression_371: 'Ocultar contacto',
    expression_372: 'Transferir Mensaje',
    expression_373: 'Distribución Automática',
    expression_374: 'Utilice este código QR en sus campañas de marketing para llevar a sus visitantes a la aplicación WhatsApp. El visitante no necesita descargar ninguna otra aplicación, solo apunte la cámara del celular a la imagen.',
    expression_375: 'Descargue su código QR de WhatsApp a continuación:',
    expression_376: 'Descargar',
    expression_377: 'Use este código QR para que sus visitantes agreguen el número de teléfono de este canal a sus calendarios de teléfonos celulares. El visitante no necesita descargar ninguna otra aplicación, solo apunte la cámara del celular a la imagen.',
    expression_378: 'Descargue su código QR para V-Card a continuación:',
    expression_379: 'Agregar medios',
    expression_380: 'Variables y formato',
    expression_381: 'Consejos:',
    expression_382: 'Usa la variable',
    expression_383: 'para mostrar el nombre del lead en el mensaje. Mostrar palabras en negrita usando',
    expression_384: 'antes y después del texto deseado. Por ejemplo, escriba:',
    expression_385: 'Resultado',
    expression_386: 'Menús de bot',
    expression_387: 'Configure las opciones que se mostrarán al contacto. El lead debe ingresar la opción deseada para ser dirigido a un departamento o contenido que usted determine a continuación.',
    expression_388: 'Agregar al menú principal',
    expression_389: 'Suporte',
    expression_390: 'Hola',
    expression_391: 'Eu sou o',
    expression_392: 'la inteligencia artificial de',
    expression_393: 'Estoy preparado para atender a sus clientes, responder preguntas y enviar ofertas, por ejemplo.',
    expression_394: 'Configure mis opciones en el menú lateral.',
    expression_395: 'Configura las opciones de tu',
    expression_396: 'Agregar departamento',
    expression_397: 'Se superó el límite de registros',
    expression_398: 'Puede crear departamentos específicos para segmentar su flujo de servicios. A continuación, establezca un "Horario de servicio", donde definirá el horario de servicio. Luego, vincule a algunos usuarios como asistentes o configure un "Chat-bot" para comenzar a mover sus llamadas.',
    expression_399: 'Clic aquí para saber más.',
    expression_400: 'Nombre de Departamento',
    expression_401: 'Tu no puedes eliminar el Departamento Predeterminado',
    expression_402: 'El usuario no está registrado como asistente.',
    expression_403: 'Terminado',
    expression_404: 'Agregar paso',
    expression_405: 'Debe tener registrado al menos un "Interés", una "Calificación" y una "Origen de Protocolo".',
    expression_406: 'Atención',
    expression_407: '¿Quieres enviar el mensaje de todos modos?',
    expression_408: 'Introduzca una fecha de inicio y una fecha de finalización para la búsqueda de su campaña.',
    expression_409: 'Ninguna etapa cadastrada.',
    expression_410: 'Agregar plantilla',
    expression_411: 'Nombre del modelo',
    expression_412: 'Categoría',
    expression_413: 'Previa',
    expression_414: 'Idiomas',
    expression_415: 'Aprobado',
    expression_416: 'Desaprobado',
    expression_417: 'Enviado',
    expression_418: 'Pendiente',
    expression_419: 'Ninguno interés registrado.',
    expression_420: 'Quieres eliminar esta plantilla?',
    expression_421: 'Si, eliminar',
    expression_422: 'Comunicaciones',
    expression_423: 'Debe configurar la integración antes de habilitarla.',
    expression_424: 'Configurar',
    expression_425: 'Activo',
    expression_426: 'Inactivo',
    expression_427: 'Necesitas ingresar un token!',
    expression_428: 'No tienes permiso para cambiar!',
    expression_429: 'Agregar interesse',
    expression_430: 'Defina aquí los posibles intereses que pueden traer sus leads al servicio. Los "intereses" pueden ser tan variados como los productos o servicios que ofrece su organización. Por ejemplo, en el caso de una tienda de autos, podríamos identificar intereses como: "Autos nuevos, autos usados y autopartes".',
    expression_431: 'Nombre de Interés',
    expression_432: "Debe tener al menos un 'Interés' cuando el embudo está habilitado.",
    expression_433: 'Agregar qualificación',
    expression_434: 'Las habilidades ayudan a generar informes y métricas para mejorar la toma de decisiones en toda su organización. Los asistentes pueden calificar los protocolos de acuerdo con el tema tratado en cada protocolo creado. Por ejemplo: "Duda, sugerencia, error".',
    expression_435: 'Nombre de Calificación',
    expression_436: "Debe tener al menos una 'Calificación' cuando el embudo está habilitado.",
    expression_437: 'Ninguna calificación registrada.',
    expression_438: 'Abertura',
    expression_439: 'Clausura',
    expression_440: 'Lunes',
    expression_441: 'Martes',
    expression_442: 'Miércoles',
    expression_443: 'Jueves',
    expression_444: 'Viernes',
    expression_445: 'Sábado',
    expression_446: 'Domingo',
    expression_447: 'Agregar asistente',
    expression_448: 'Una vez que haya creado departamentos y definido su lista de servicios, podrá vincular a sus usuarios como agentes para ese canal. De esta forma, estos usuarios tendrán acceso al "Chat" en tiempo real con los leads, según el flujo de servicio definido por usted.',
    expression_449: 'Nombre del asistente',
    expression_450: 'Ningún asistente registrado.',
    expression_451: 'Temporización',
    expression_452: 'Tiempo de Inactividad (Operador)',
    expression_453: 'Establezca el tiempo máximo que sus agentes deben responder a una llamada. Se mostrará una alerta al agente dentro del plazo que estipula a continuación para que pueda continuar con el servicio abierto.',
    expression_454: 'minutos',
    expression_455: 'Operador automático de tiempo de inactividad',
    expression_456: 'Establezca la cantidad máxima de tiempo que desea esperar una respuesta de su lead en CHATBOT. BOT enviará un mensaje y cerrará automáticamente el protocolo cuando alcance el período que ingresa a continuación.',
    expression_457: 'Tiempo de Inactividad (Contact)',
    expression_458: 'Establezca un límite de tiempo para esperar una interacción de su lead. Se enviará un mensaje automático y el protocolo se cerrará automáticamente cuando llegue al período informado a continuación.',
    expression_459: 'Protocolo de tiempo de inactividad',
    expression_460: 'Establezca un período de tiempo en el que el sistema ignorará los nuevos mensajes de leads después de que se cierre un protocolo. Informar a continuación cuánto tiempo.',
    expression_461: 'Tiempo de inactividad Intentos no válidos',
    expression_462: 'Establezca el número máximo de intentos inválidos que un lead puede ingresar en CHATBOT. Se enviará un mensaje automático y el protocolo se cerrará cuando alcance el monto informado a continuación.',
    expression_463: 'veces',
    expression_464: 'mensajes del sistema',
    expression_465: 'Programe mensajes automáticas que se enviarán según la etapa del servicio.',
    expression_466: 'Bienvenida',
    expression_467: 'Este texto se enviará cada vez que su canal reciba el primer mensaje de un lead.',
    expression_468: "Ejemplo: 'Hola, {{NAME}}! Gracias por contactarnos. Ahora comenzaremos su servicio.'",
    expression_469: 'Cierre',
    expression_470: 'Mensaje que se enviará cada vez que se finalice un protocolo.',
    expression_471: "Ej: 'Agradecemos su contacto. Hasta pronto!'",
    expression_472: 'Inactividad del operador',
    expression_473: "Este mensaje de alerta se mostrará a su asistente, respetando la fecha límite que estableció en el tiempo de 'Tiempo de Inactividad (Operador)'",
    expression_474: "Ej: 'Atención! Debe continuar la llamada o finalizarla.'",
    expression_475: "Este mensaje se mostrará a tu lead cuando deje de interactuar con el canal dentro del plazo que estableciste en el tiempo de 'Plazo de entrega'.",
    expression_476: 'Inactividad de Contacto',
    expression_477: "Ej: 'Por falta de interacción, el servicio fue cancelado. Vuelve cuando quieras.'",
    expression_478: "Ej: 'Por falta de interacción, el servicio fue cancelado. Vuelve cuando quieras.'",
    expression_479: "Autoservicio de inactividad",
    expression_480: "Este mensaje se mostrará a su lead cuando deje de interactuar con el BOT, respetando la fecha límite que estableció en el tiempo de 'Tiempo de Inactividad (Chat-Bot)'",
    expression_481: "Ej: 'Agradecemos el contacto y estaremos disponibles.'",
    expression_482: "Fuera de Escala de Tiempo",
    expression_483: "Este mensaje se enviará a los leads que interactúen con el canal fuera del horario de apertura informado en la 'ESCALA DE SERVICIO' de cada departamento.",
    expression_484: "Estimado cliente, hemos terminado con el servicio de hoy. Nuestro horario de atención es de lunes a viernes, de 9AM a 18PM.",
    expression_485: "Encuesta de satisfacción",
    expression_486: "Este mensaje se enviará al lead pidiéndole que responda a una encuesta de satisfacción con respecto al servicio.",
    expression_487: "Tenerte como cliente nos motiva a ofrecer siempre los mejores servicios. Haga clic en el enlace y califique nuestro servicio.",
    expression_488: "Investigación de cierre",
    expression_489: "Mensaje que se mostrará cuando el cliente responda a la encuesta de satisfacción.",
    expression_490: "Gracias por responder! Con su ayuda, podremos mejorar aún más nuestro servicio.",
    expression_491: 'Editar plan',
    expression_492: 'Cancelar editar',
    expression_493: 'Funciones',
    expression_494: 'Cantidad',
    expression_495: 'Usado',
    expression_496: 'Límite excedido! Si necesita más, busque a su consultor y contrate.',
    expression_497: 'Información actualizada a cada 1 (una) hora.',
    expression_498: 'Si',
    expression_499: 'No',
    expression_500: 'Respuestas Rápidas',
    expression_501: 'Agregar una respuesta',
    expression_502: 'Límite de registros excedido',
    expression_503: 'Estandarice y automatice el envío de respuestas con la ayuda de esta función. Podrás definir textos específicos para cada departamento y enriquecer los mensajes adjuntando imágenes. Estas respuestas se mostrarán a los asistentes en el "Chat".',
    expression_504: 'Atajo / Marcador',
    expression_505: 'Mensaje',
    expression_506: 'Imagen',
    expression_507: 'Sin respuesta registrada.',
    expression_508: 'Pausa',
    expression_509: 'Reanudar',
    expression_510: 'Todos los tipos',
    expression_511: 'Oportunidades',
    expression_512: 'Galería',
    expression_513: 'HSM',
    expression_514: "Agregar tag",
    expression_515: 'Las etiquetas se utilizan para agrupar varios leads en una clasificación determinada. Con la ayuda de esta función, podrá segmentar sus campañas de marketing u obtener informes más detallados. Ejemplo: "Prospectos, Clientes, Empleados", etc.',
    expression_516: "Nombre da Tag",
    expression_517: "Sin tag registrada.",
    expression_518: "Textos de Widget",
    expression_519: "Utilice este espacio para atraer a sus visitantes con una mensaje corto.",
    expression_520: "Título del Widget",
    expression_521: "Mensaje de saludo",
    expression_522: "Mensaje de finalización",
    expression_523: "Personalizar el estilo",
    expression_524: "Utilice este espacio para atraer a sus visitantes con una mensaje corto.",
    expression_525: "Posición",
    expression_526: "Lado derecha",
    expression_527: "Lado izquierda",
    expression_528: "Color del boton",
    expression_529: "Eliminar imagen",
    expression_530: "Adjuntar archivo",
    expression_531: "Inserte este código en su sitio web",
    expression_532: "Copie el código a continuación y péguelo en su sitio web, dentro de la tag",
    expression_533: "Previa del Widget",
    expression_534: "Envío de SMS",
    expression_535: "Conexión VoIP",
    expression_536: "Envío de HSM",
    expression_537: "Inicio",
    expression_538: "Transferir",
    expression_539: "Continuar protocolo",
    expression_540: "Pausar protocolo",
    expression_541: "Terminar",
    expression_542: "Otras opciones",
    expression_543: "Contacto",
    expression_544: "Localización",
    expression_545: "beta",
    expression_546: "Histórico",
    expression_547: "Variables",
    expression_548: "info",
    expression_549: "Minimizar",
    expression_550: "Detalles",
    expression_551: "No se encontraron respuestas rápidas.",
    expression_552: "Emojis",
    expression_553: "Adjuntar archivo",
    expression_554: "Este lead no tiene una cuenta válida en WhatsApp",
    expression_555: "No tiene una interacción abierta con este lead.",
    expression_556: "Escriba algo o / para acceder a respuestas rápidas...",
    expression_557: "Grabando audio...",
    expression_558: "Grabar audio",
    expression_559: "Enviar mensaje",
    expression_560: "Enviar plantillas de mensajes",
    expression_561: "Parar grabación",
    expression_562: "Enviar",
    expression_563: "Eliminar grabación",
    expression_564: "Información del contacto",
    expression_565: "Perfil",
    expression_566: "Sexo",
    expression_567: "Indefinido",
    expression_568: "Femenino",
    expression_569: "Masculino",
    expression_570: "Ingrese su anotación...",
    expression_571: "Ninguna anotación.",
    expression_572: "Valor da Negociación",
    expression_573: "Negociación Ganada",
    expression_574: "Negociación perdió",
    expression_575: "Descripción",
    expression_576: "Ninguno interés",
    expression_577: "Ninguna calificación",
    expression_578: "Ningún origen",
    expression_579: "Buscar lead en el chat...",
    expression_580: "Buscar lead en la agenda...",
    expression_581: "Buscar en la agenda",
    expression_582: "no tienes chats activos!",
    expression_583: "Una vez que se inicia una nueva conversación, aparecerá aquí.",
    expression_584: "Debe confirmar su dirección de correo electrónico.",
    expression_585: "Reenviar correo electrónico de confirmación",
    expression_586: "ESPERANDO",
    expression_587: "Atendiendo",
    expression_588: "ATENDIENDO",
    expression_589: "Pausado",
    expression_590: "PAUSADO",
    expression_591: "Fuera de horario",
    expression_592: "Clasificación",
    expression_593: "negociaciones",
    expression_594: "No notificaciones.",
    expression_595: "Tipo do canal",
    expression_596: "Elija un tipo...",
    expression_597: "Crear canal",
    expression_598: "Elija un usuario ...",
    expression_599: "Registrar nuevo canal",
    expression_600: "Agregar asistente al canal",
    expression_601: "Campaña pausada",
    expression_602: "Nombre del paso",
    expression_603: "Fecha de Inicio",
    expression_604: "Fecha de Vencimiento",
    expression_605: "Elija un asistente ...",
    expression_606: 'Registrar nuevo lead',
    expression_607: 'Lea las instrucciones a continuación antes de registrar un nuevo lead! Si ingresa números sin seguir este patrón, es posible que tenga protocolos y leads duplicados dentro del sistema. Estas son reglas expresas de la aplicación WhatsApp.',
    expression_608: 'Cómo registrarse',
    expression_609: 'Para registrar un lead en',
    expression_610: 'utilice el estándar numérico internacional, incluido DDI (código de país) y DDD (por ejemplo: 5511988776655), sin espacios ni ningún otro tipo de carácter. Si no sigue estos estándares, no podrá comunicarse con el lead.',
    expression_611: 'Noveno dígito para WhatsApp',
    expression_612: 'Solo los números de los estados de ES, RJ y SP pueden recibir el noveno dígito. Números de otros estados',
    expression_613: 'debe ingresarse usando el noveno dígito.',
    expression_614: 'Ejemplos',
    expression_615: 'Con el noveno dígito',
    expression_616: 'Sin el noveno dígito',
    expression_617: 'Este campo es obligatorio',
    expression_618: 'Campos obligatórios',
    expression_619: 'Este lead ya está registrado en este canal y tiene un protocolo abierto.',
    expression_620: '¡Este lead ya está registrado en este canal!',
    expression_621: 'Abrir protocolo',
    expression_622: 'Acepto y quiero seguir',
    expression_623: 'Complete los campos de arriba',
    expression_624: 'Este lead no le pertenece.',
    expression_625: 'Debe seleccionar un canal y un departamento.',
    expression_626: 'Vincular asistente',
    expression_627: 'Has superado el límite de asistentes registrados.',
    expression_628: 'Agregar respuesta rápida',
    expression_629: 'Marcación',
    expression_630: 'Las marcaciones ayudan a organizar sus respuestas.',
    expression_631: 'Contenido del Mensaje',
    expression_632: 'Haga clic para adjuntar un archivo.',
    expression_633: 'Tipos permitidos: JPG, JPEG o PNG.',
    expression_634: 'El tamaño máximo por archivo es de 15MB.',
    expression_635: 'Nombre de la tarea',
    expression_636: 'Nombre del destinatario',
    expression_637: 'Elija un destinatario...',
    expression_638: 'Prioridad',
    expression_639: 'Elija una prioridad...',
    expression_640: 'Guardar tarea',
    expression_641: 'Crear plantilla HSM',
    expression_642: 'Los ejemplos se cargarán en Facebook como parte del proceso de aprobación de la plantilla. Si no se informan ejemplos, las plantillas pueden ser rechazadas por Facebook.',
    expression_643: 'Campo obligatorio',
    expression_644: 'Los nombres siempre deben estar en minúsculas, números y / o subrayados. No se aceptan caracteres especiales.',
    expression_645: 'Categoría de mensaje',
    expression_646: 'Elija una categoría...',
    expression_647: 'Idioma',
    expression_648: 'Elija un idioma...',
    expression_649: 'Seleccionar bloques de construcción de plantilla',
    expression_650: 'Encabezamiento',
    expression_651: 'Cuerpo',
    expression_652: 'Rodapié',
    expression_653: 'Botones',
    expression_654: 'Ingrese el texto del encabezado de su plantilla aquí...',
    expression_655: 'caracteres',
    expression_656: 'variable',
    expression_657: 'Ingrese el texto principal de su plantilla...',
    expression_658: 'Ingrese aquí el texto del pie de página de la plantilla...',
    expression_659: 'Agregar botón',
    expression_660: 'Botón',
    expression_661: 'Respuesta Rápida',
    expression_662: 'Ingrese el texto de respuesta rápida...',
    expression_663: 'Ingrese el texto para el botón...',
    expression_664: 'Ingrese el número de teléfono...',
    expression_665: 'Ingresa el texto de la CTA...',
    expression_666: 'Ingrese la URL...',
    expression_667: 'Elija el tipo y agregue un botón.',
    expression_668: 'Ejemplo de Plantilla',
    expression_669: 'No usaste ninguna variable. Esto puede afectar la aprobación de su plantilla con Facebook.',
    expression_670: 'Botón de URL',
    expression_671: 'Previa de la plantilla',
    expression_672: 'Tu encabezado aparecerá aquí...',
    expression_673: 'Tu pie de página aparecerá aquí...',
    expression_674: 'Su plantilla ha sido enviada para su aprobación.!',
    expression_675: 'Facebook puede tardar hasta',
    expression_676: '5 días laborables',
    expression_677: 'para aprobar su plantilla HSM.',
    expression_678: 'ver previa',
    expression_679: 'Complete los campos obligatorios',
    expression_680: 'Guardar y continuar',
    expression_681: 'El tamaño máximo permitido por archivo es de {size}.',
    expression_682: 'Revisa el archivo',
    expression_683: 'Atención!',
    expression_684: 'Tipo de archivo no permitido.',
    expression_685: 'Tipo permitido: PDF.',
    expression_686: 'Registrar nuevo usuario',
    expression_687: 'Nivel de acceso',
    expression_688: 'Supervisor',
    expression_689: 'Administrador',
    expression_690: 'Guardar usuario',
    expression_691: 'Agregar lead a la billetera',
    expression_692: 'Ninguno asistente...',
    expression_693: 'Agregar',
    expression_694: 'Enviar correo electrónico',
    expression_695: 'Destinatario:',
    expression_696: 'Eliminar',
    expression_697: 'La respuesta a cualquier correo electrónico enviado por el sistema llegará a su buzón.:',
    expression_698: 'Asegúrese de que este buzón sea válido y accesible para usted.',
    expression_699: 'Asunto',
    expression_700: 'Campaña reanudada',
    expression_701: 'Estado da Negociación',
    expression_702: 'Complete todos los campos de arriba.',
    expression_703: 'Enviar medios',
    expression_704: 'enviar medios',
    expression_705: 'Tipos permitidos: JPG, JPEG, PNG, WEBP, PDF, MP3, DOC, DOCX, XLS y XLSX.',
    expression_706: 'Subtitular...',
    expression_707: 'Historial de Protocolos',
    expression_708: 'Fecha',
    expression_709: 'No hay historial de protocolos disponible.',
    expression_710: 'Enviar Localización',
    expression_711: 'Escriba la dirección y presione Intro o haga clic en buscar',
    expression_712: 'Buscar',
    expression_713: 'Informaciones do protocolo',
    expression_714: 'Enviar SMS',
    expression_715: 'Ingresar mensaje:',
    expression_716: 'Transferir protocolo',
    expression_717: 'Enviar V-card',
    expression_718: 'Editar departamento',
    expression_719: '¿Quieres pausar esta campaña?',
    expression_720: 'Editar meta',
    expression_721: 'Eliminar meta',
    expression_722: 'Editar interesar',
    expression_723: 'Editar Contact',
    expression_724: 'Editar calificación',
    expression_725: 'Editar configuraciones del plan',
    expression_726: 'Seleccionar correo electrónico de administrador',
    expression_727: 'Seleccione un contacto...',
    expression_728: 'Ingrese el código de 4 dígitos',
    expression_729: 'Código validado con éxito!',
    expression_730: 'Codigo invalido!',
    expression_731: 'Enviar el código de verificación',
    expression_732: 'Reenviar código',
    expression_733: 'Validar!',
    expression_734: 'Editar respuesta rápida',
    expression_735: '¿Quieres iniciar la campaña?',
    expression_736: 'Editar tag',
    expression_737: 'Editar tarea',
    expression_738: 'Tarea asignada a',
    expression_739: 'Tarea creada por',
    expression_740: 'No tienes permiso para editar este campo.',
    expression_741: 'Elija un estado...',
    expression_742: 'Eliminar tarea',
    expression_743: 'Importación de leads',
    expression_744: 'Reglas de Importación:',
    expression_745: 'Los archivos deben estar en formato .CSV o .XLS (Excel) y tener hasta 3 (tres) columnas:',
    expression_746: 'La columna "CORREO ELECTRÓNICO" es opcional;',
    expression_747: 'Los números de teléfono deben seguir el estándar internacional (DDI + DDD + Número). Ejemplo: 5511988887777',
    expression_748: 'El límite de contactos importados por archivo es de 2 mil (dos mil) contactos.',
    expression_749: 'Los archivos deben tener solo una "pestaña" que contenga las columnas descritas anteriormente.',
    expression_750: 'Descargar modelo',
    expression_751: 'Importar archivo',
    expression_752: 'Estamos validando tus leads...',
    expression_753: 'Le avisaremos con una notificación una vez que se hayan importado todos los leads...',
    expression_754: 'números inválidos de',
    expression_755: 'Algunos contactos de su lista tienen un error en el patrón de números. Puede cargar otro archivo con las correcciones necesarias o continuar con la importación eliminando los números no válidos.',
    expression_756: 'Consulte la lista de números de problemas a continuación..',
    expression_757: 'Cargar otra lista',
    expression_758: 'Eliminar contactos no válidos',
    expression_759: 'Línea',
    expression_760: 'Error',
    expression_761: '¡Excelente! Ahora elija a qué canal y / o tag se vincularán estos Contacts.',
    expression_762: 'Estamos procesando su lista de Contacts.',
    expression_763: 'Esto puede llevar un tiempo dependiendo del tamaño. Sea paciente.',
    expression_764: 'Importación completada.',
    expression_765: 'No tiene número o los encabezados no se han cambiado.',
    expression_766: 'Continuar importando',
    expression_767: 'Necesita generar un token con este proveedor para integrar.',
    expression_768: 'Conseguir token!',
    expression_769: 'Acerca de RD Station CRM',
    expression_770: 'Controle su proceso comercial y aumente las ventas con el nuevo CRM de RD Station. ¡Es hora de tirar las sábanas! Registre automáticamente sus acciones, nunca olvide hacer un seguimiento y centralizar todo en un solo lugar.',
    expression_771: 'Acerca de Agendor',
    expression_772: 'Agendor es una plataforma de gestión comercial y CRM con versiones web y móvil (Android e iOS) que funciona como panel de control para el gerente comercial y asistente de ventas personal para los equipos de ventas B2B.',
    expression_773: 'Acerca de HubSpot',
    expression_774: 'En resumen, el CRM de HubSpot es un software que te permite controlar el proceso de ventas con facilidad, permitiendo una gestión completa de leads, prospectos y pipeline de ventas.',
    expression_775: 'Acerca de Nectar CRM',
    expression_776: '¡Todo lo que necesita para un alto rendimiento de ventas! Realice un seguimiento de sus oportunidades de ventas en detalle a través de una canalización visual, intuitiva y completa.',
    expression_777: 'Acerca de Pipedrive',
    expression_778: 'Pipedrive es una plataforma similar a CRM creada para facilitar la gestión de ventas para empresas en crecimiento. La herramienta se basa en la venta de actividades, por lo que Pipedrive fue diseñado para satisfacer las necesidades de gerentes y vendedores.',
    expression_779: 'Acerca de RBX Soft',
    expression_780: 'La plataforma está preparada para paquetes de servicios, multiempresas y franquicias. Una solución modular que se puede personalizar según las necesidades del cliente. La atención se centra en la transformación constante y la evolución lógica del crecimiento del mercado supercompetitivo y dinámico.',
    expression_781: 'Acerca de Followize',
    expression_782: 'Followize es un software de gestión de leads diseñado para ayudar a las empresas que reciben leads a través de Internet y tienen dificultades para gestionar nuevas demandas desde el primer contacto hasta la decisión de compra.',
    expression_783: 'Acerca de BSMS',
    expression_784: 'Integración con la plataforma BSMS.',
    expression_785: 'Acerca de API Oficial Meta',
    expression_786: 'Integración con la API oficial de WhatsApp.',
    expression_787: 'Acerca do VOIP',
    expression_788: 'Integración con socio VOIP para llamadas VoIP.',
    expression_789: 'Acerca de WATI',
    expression_790: 'Cómo funciona esta integración?',
    expression_791: 'Al integrar su CRM con RDStation, automáticamente compartirá la información de sus leads con ese proveedor. La información que se puede enviar es la siguiente: Nombre, Empresa, Teléfono y E-mail.',
    expression_792: 'Al integrar su CRM con el Programador, automáticamente compartirá la información de sus leads con ese proveedor. La información que se puede enviar es la siguiente: Nombre, Teléfono y E-mail.',
    expression_793: 'Al integrar tu CRM con HubSpot, automáticamente compartirás la información de tus leads con ese proveedor. La información que se puede enviar es la siguiente: Nombre, E-mail y Teléfono.',
    expression_794: 'Al integrar su CRM con NectarCRM, automáticamente compartirá la información de sus leads con ese proveedor. La información que se puede enviar es la siguiente: Nombre, E-mail y Teléfono.',
    expression_795: 'Al integrar su CRM con PipeDrive, automáticamente compartirá la información de sus leads con ese proveedor. La información que se puede enviar es la siguiente: Nombre, E-mail y Teléfono.',
    expression_796: 'Al integrar tu CRM con RBXSoft podrás entregar automáticamente los resguardos a tus clientes escribiendo CPF o CNPJ correspondiente al registro con tu empresa.',
    expression_797: 'Al integrar su CRM con Followize, automáticamente compartirá la información de sus leads con ese proveedor. La información que se puede enviar es la siguiente: Nombre, E-mail y Teléfono.',
    expression_798: '¡Integración no realizada! Debes ingresar el token para continuar.',
    expression_799: 'Descargar PDF',
    expression_800: 'Diferencias en los registros',
    expression_801: 'Antes',
    expression_802: 'Después',
    expression_803: 'Detalles de la notificación',
    expression_804: 'Ver tareas',
    expression_805: 'Marcar como leído',
    expression_806: 'Marcar como no leído',
    expression_807: 'Este lead ya tiene un protocolo abierto (protocolo).',
    expression_808: 'Buscar campaña',
    expression_809: 'Final',
    expression_810: 'Limpiar filtros',
    expression_811: 'Buscar',
    expression_812: 'Numero de canal',
    expression_813: 'Buscar un lead',
    expression_814: 'Fecha de inicio',
    expression_815: 'Fecha final',
    expression_816: 'Estado del protocolo',
    expression_817: 'Todos',
    expression_818: 'Nombre',
    expression_819: 'Teléfono',
    expression_820: 'Buscar un usuario',
    expression_821: 'Enviar mensaje HSM',
    expression_822: 'Los mensajes modelo se procesan individualmente, con la aplicación de tarifas por envío.',
    expression_823: 'No hay plantilla registrada.',
    expression_824: 'Editar Variables',
    expression_825: 'Tipos permitidos: MPEG, MP4.',
    expression_826: 'Búsqueda de Satisfacción',
    expression_827: 'Cambiar contraseña de usuario',
    expression_828: 'La contraseña no puede estar vacía.',
    expression_829: 'Ingrese la nueva contraseña::',
    expression_830: 'Guardar contraseña',
    expression_831: 'Acción masiva en la Cartera',
    expression_832: 'Elije una acción...',
    expression_833: 'Eliminar leads de la billetera',
    expression_834: 'Transferir leads',
    expression_835: 'Eliminar leads',
    expression_836: 'Variables disponibles',
    expression_837: 'Puede utilizar las siguientes variables para insertar información de forma dinámica en los mensajes.',
    expression_838: 'Inintroduzca el nombre del lead.',
    expression_839: 'Inserta el enlace para suscribirte al canal de campañas.',
    expression_840: 'Ingrese el nombre del asistente.',
    expression_841: 'Ingrese el nombre del departamento.',
    expression_842: 'Ingrese el número de protocolo.',
    expression_843: 'Formatación de Texto',
    expression_844: 'Para formatear el texto de los mensajes, debe agregar los caracteres a continuación, antes y después de cada palabra que desee modificar. Por ejemplo, escriba:',
    expression_845: 'Resultado:',
    expression_846: 'asterisco:',
    expression_847: 'Adiciona',
    expression_848: 'negrita',
    expression_849: 'itálico',
    expression_850: 'riscado',
    expression_851: 'al texto.',
    expression_852: 'underline',
    expression_853: 'acento',
    expression_854: 'Detalles de los medios',
    expression_855: 'Descargar',
    expression_856: 'Llamada de VoIP',
    expression_857: 'Iniciar llamada',
    expression_858: 'R$ 0.95 por minuto',
    expression_859: 'Crear menú principal',
    expression_860: 'Crear submenú',
    expression_861: 'Detalles de la campaña',
    expression_862: 'Esta campaña se completó con éxito!',
    expression_863: 'Esta campaña se está ejecutando.',
    expression_864: 'Esta campaña está programada.',
    expression_865: 'Contenido',
    expression_866: 'Media',
    expression_867: 'Fecha de Creación',
    expression_868: 'Fecha de Finalización',
    expression_869: 'Campaña creada por',
    expression_870: 'Cancelar el envío',
    expression_871: 'De verdad quieres cancelar esta campaña?',
    expression_872: 'Si, cancelar',
    expression_873: 'Tipos permitidos: JPG, JPEG, PNG, MP4 y PDF.',
    expression_874: 'Elija el departamento que debe recibir estos protocolos.',
    expression_875: 'Elija un asistente para recibir estos protocolos.',
    expression_876: 'Escriba su nombre:',
    expression_877: 'Introduce tu correo electrónico:',
    expression_878: 'Su WhatsApp',
    expression_879: 'Acepto recibir promociones.',
    expression_880: 'Recibimos tu contacto!',
    expression_881: 'Agradecemos el interés. Envía un mensaje a nuestro WhatsApp.',
    expression_882: 'Quieres eliminar este interés?',
    expression_883: 'Quieres eliminar esta respuesta?',
    expression_884: 'Error al enviar el mensaje, vuelve a intentarlo',
    expression_885: 'Quieres eliminar esta tag?',
    expression_886: 'El tamaño máximo permitido por archivo es de 2 MB..',
    expression_887: 'Quieres eliminar este enlace?',
    expression_888: 'Esta acción eliminará el vínculo de esta etiqueta con el lead en cuestión.',
    expression_889: 'Introduzca una nota para guardar.',
    expression_890: 'Esta acción eliminará el vínculo de este lead con el usuario en cuestión..',
    expression_891: 'Contact agregado con éxito!',
    expression_892: 'Tipos permitidos: JPG, JPEG y PNG.',
    expression_893: 'Usuario creado con éxito!',
    expression_894: 'Sinceramente,',
    expression_895: 'Quieres cerrar este protocolo?',
    expression_896: 'Si, terminar',
    expression_897: 'Solo se permite enviar 3 archivos a la vez.',
    expression_898: 'Quieres eliminar esta meta?',
    expression_899: 'Quieres eliminar esta tarea?',
    expression_900: 'Está seguro de que desea importar?',
    expression_901: 'Si, importar',
    expression_902: 'Quieres eliminar esta notificación?',
    expression_903: 'Todos los estados',
    expression_904: 'Bot registrado con éxito!',
    expression_905: 'Bot editado con éxito!',
    expression_906: 'Eliminado!',
    expression_907: 'El bot ha sido eliminado.',
    expression_908: 'Cancelado!',
    expression_909: 'Campaña eliminada con éxito!',
    expression_910: 'Campaña creada con éxito!',
    expression_911: 'Canal editado correctamente!',
    expression_912: 'Canal registrado correctamente!',
    expression_913: 'Protocolo transferido con éxito!',
    expression_914: 'Protocolo completado con éxito!',
    expression_915: 'lead registrado correctamente',
    expression_916: 'Panel de Control',
    expression_917: 'Departamento registrado correctamente!',
    expression_918: 'Departamento editado correctamente!',
    expression_919: 'El departamento ha sido eliminado.',
    expression_920: 'La campaña se detuvo con éxito.',
    expression_921: 'La campaña se reanudó con éxito.',
    expression_922: 'Esta campaña está en pausa.',
    expression_923: 'En pausa',
    expression_924: 'Subir archivos',
    expression_925: 'Eliminada!',
    expression_926: '',
    expression_927: 'Mensajes eliminados de la cola de envío!',
    expression_928: 'Interés registrado con éxito!',
    expression_929: 'Interés editado con éxito!',
    expression_930: 'El interesse ha sido eliminado.',
    expression_931: 'Tag vinculada correctamente!',
    expression_932: 'La tag se ha desvinculado.',
    expression_933: 'Las informaciones fueron cambiadas con éxito!',
    expression_934: 'Generando archivo...',
    expression_935: 'No se preocupe, le avisaremos con una notificación cuando hayamos terminado.',
    expression_936: 'El correo electrónico informado no está registrado en el sistema.',
    expression_937: 'Enviamos un mensaje a su correo electrónico. Haga clic en el enlace del mensaje para confirmar su dirección de correo electrónico.',
    expression_938: 'Revise su buzón, incluida la basura / spam.',
    expression_939: 'E-mail enviado!',
    expression_940: 'Calificación registrada con éxito!',
    expression_941: 'Calificación editada con éxito!',
    expression_942: 'La alificación ha sido eliminada.',
    expression_943: 'Anotación creada con éxito!',
    expression_944: 'Calificación editada con éxito!',
    expression_945: 'La calificación ha sido eliminada.',
    expression_946: 'Eliminado!',
    expression_947: 'La notificación ha sido eliminada.',
    expression_948: 'Las notificaciones ha sido eliminadas.',
    expression_949: 'Operador registrado con éxito!',
    expression_950: 'El Operador ha sido eliminada.',
    expression_951: 'Exportación en proceso.',
    expression_952: 'Al concluir, mostraremos una notificación.',
    expression_953: 'Respuesta registrado con éxito!',
    expression_954: 'Resposta editada con éxito!',
    expression_955: 'A resposta ha sido eliminada.',
    expression_956: 'Cada 13 días deberás encender tu dispositivo para que WhatsApp mantenga conectada tu cuenta. De lo contrario, la comunicación se interrumpirá y tendrás que repetir el proceso de conexión.',
    expression_957: 'Generar código QR',
    expression_958: 'Éxito',
    expression_959: 'Tag cadastrada con éxito!',
    expression_960: 'Tag editada con éxito!',
    expression_961: 'A tag ha sido eliminada.',
    expression_962: 'Tarea cadastrada con éxito!',
    expression_963: 'Tarea editada con éxito!',
    expression_964: 'A tarea ha sido eliminada.',
    expression_965: 'Plantilla editado con éxito!',
    expression_966: 'Plantilla ha sido eliminada.',
    expression_967: 'O usuário ha sido eliminado.',
    expression_968: 'Usuário restaurado con éxito!',
    expression_969: 'Qué es lo que quieres hacer?',
    expression_970: 'El lead ha sido eliminado de la billetera.',
    expression_971: 'Cartera ligada con éxito!',
    expression_972: 'El leads foram eliminados de la billetera!',
    expression_973: 'Contacts transferidos con éxito!',
    expression_974: 'Widget editado con éxito!',
    expression_975: 'De verdad quieres enviar esta campaña??',
    expression_976: 'Al hacer clic en Continuar, aceptas las',
    expression_977: 'Metatérminos para WhatsApp Business',
    expression_978: 'Continuar',
    expression_979: 'Tipos permitidos: JPG, JPEG, PNG y MP4.',
    expression_980: 'del Departamento',
    expression_981: 'del Canal',
    expression_982: 'Página no encontrada.',
    expression_983: 'Volver al dashboard',
    expression_984: 'Para recuperar su contraseña, ingrese el correo electrónico registrado.',
    expression_985: 'Enviar enlace de recuperación',
    expression_986: 'Enlace enviado!',
    expression_987: 'Enviamos un correo electrónico a',
    expression_988: 'con las informaciones sobre cómo recuperar su contraseña. Revise su buzón, incluida la Papelera / Spam.',
    expression_989: 'Hacer login',
    expression_990: 'Ahora, crea una nueva contraseña de acceso:',
    expression_991: 'Guardar nueva contraseña',
    expression_992: 'Excelente,',
    expression_993: 'Contraseña cambiada con éxito!',
    expression_994: 'Contraseña demasiado corta.',
    expression_995: 'Quieres eliminar este lead de la billetera??',
    expression_996: 'Quieres eliminar este asistente??',
    expression_997: 'No se permite cambiar el nivel de acceso cuando hay un enlace de asistente en cualquier canal.',
    expression_998: 'Cambiar la contraseña',
    expression_999: 'Logs',
    expression_1000: 'Canales Vinculados',
    expression_1001: 'Haga clic en el nombre del canal para vincular a este usuario',
    expression_1002: 'Este usuario aún no tiene acceso a ningún canal.',
    expression_1003: 'Logs de Actividad',
    expression_1004: 'ID da Origen',
    expression_1005: 'Diferencias',
    expression_1006: 'Dirección IP',
    expression_1007: 'Ver diferencias',
    expression_1008: 'Ninguno log registrado para este usuario.',
    expression_1009: 'Billetera de Contacts',
    expression_1010: 'Acción masiva',
    expression_1011: 'Ninguno lead registrado nesta billetera.',
    expression_1012: 'Disponibilidade',
    expression_1013: 'Eliminar usuario',
    expression_1014: 'En línea',
    expression_1015: 'Desconectado',
    expression_1016: 'En',
    expression_1017: 'departamentos/canales',
    expression_1018: 'Ninguno usuario ha sido registrado hasta el momento.',
    expression_1019: 'Quieres eliminar este usuario?',
    expression_1020: 'Enero',
    expression_1021: 'Febrero',
    expression_1022: 'Marcha',
    expression_1023: 'Abril',
    expression_1024: 'Mayo',
    expression_1025: 'Junio',
    expression_1026: 'Julio',
    expression_1027: 'Agosto',
    expression_1028: 'Septiembre',
    expression_1029: 'Octubre',
    expression_1030: 'Noviembre',
    expression_1031: 'Diciembre',
    expression_1032: 'Hoy dia',
    expression_1033: 'Mes',
    expression_1034: 'Semana',
    expression_1035: 'Día',
    expression_1036: 'Lista',
    expression_1037: 'No hay tareas programadas para esa fecha.',
    expression_1038: 'Informe de correo electrónico',
    expression_1039: 'Informe de envío de HSM',
    expression_1040: 'Informe de SMS',
    expression_1041: 'Informe de llamadas VoIP',
    expression_1042: 'Buscar correos electrónicos',
    expression_1043: 'Hasta ahora no se han enviado correos electrónicos.',
    expression_1044: 'Buscar HSM',
    expression_1045: 'Hasta ahora no se ha enviado ningún HSM.',
    expression_1046: 'Buscar SMS',
    expression_1047: 'Hasta ahora no se ha enviado ningún SMS.',
    expression_1048: 'Buscar Voip',
    expression_1049: 'Hasta el momento no se han realizado llamadas.',
    expression_1050: 'Distribuya los clientes potenciales de manera uniforme a sus agentes.',
    expression_1051: 'y',
    expression_1052: 'Informe de encuesta de satisfacción',
    expression_1053: 'Fotos y vídeos',
    expression_1054: 'Tarifa de apertura',
    expression_1055: 'Datos no disponibles.',
    expression_1056: 'Estado (beta)',
    expression_1057: 'Webhooks',
    expression_1058: 'Tokens',
    expression_1059: 'Agregar token',
    expression_1060: 'Mensajes recibidos',
    expression_1061: 'Estado del mensaje',
    expression_1062: 'Informe al webhook que recibirá mensajes de su canal.',
    expression_1063: 'Informe al webhook que recibirá mensajes de estado.',
    expression_1064: 'Ejemplos de payload',
    expression_1065: 'Ver ejemplos de payload',
    expression_1066: 'Vencimiento',
    expression_1067: 'Token',
    expression_1068: 'Nunca',
    expression_1069: '7 dias',
    expression_1070: '24 horas',
    expression_1071: '12 horas',
    expression_1072: '4 horas',
    expression_1073: 'Editar token',
    expression_1074: '¡Token copiado con éxito!',
    expression_1075: 'Elija un período de vencimiento del token...',
    expression_1076: 'Haga clic para copiar este token',
    expression_1077: '¿Quieres eliminar este token?',
    expression_1078: 'Timeline',
    expression_1079: 'Caducado',
    expression_1080: 'Fecha límite',
    expression_1081: 'Dupdo',
    expression_1082: '¡Felicidades! Ha importado una lista válida.',
    expression_1083: 'Continuar con la importación',
    expression_1084: 'Para enviar un contacto en',
    expression_1085: 'utilice el estándar numérico internacional, incluidos DDI (código de país) y DDD (por ejemplo: 5511988888888), sin espacios ni ningún otro tipo de carácter. Si el contacto no tiene WhatsApp, el número se enviará solo como un mensaje de texto.',
    expression_1086: 'Enviar vCard',
    expression_1087: 'Enviar',
    expression_1088: 'Cerrado',
    expression_1089: 'Transferido',
    expression_1090: 'Rechazado',
    expression_1091: 'Inactividad del asistente',
    expression_1092: 'Inactividad de Contact',
    expression_1093: 'Mensaje de sistema',
    expression_1094: 'Para obtener más información sobre cómo integrar a través de API, ',
    expression_1095: 'haga clic aquí para leer la documentación.',
    expression_1096: 'Usted',
    expression_1097: 'Respuesta',
    expression_1098: 'Uso crítico del sistema',
    expression_1099: '¡Tienes muchas convocatorias abiertas! Esto puede causar un uso lento del sistema debido a la cantidad de información que se procesa en su computadora. Para un uso saludable del sistema, le recomendamos encarecidamente que cierre los protocolos abiertos.',
    expression_1100: 'No hay canales vinculados',
    expression_1101: 'Canal vinculado',
    expression_1102: 'Migración',
    expression_1103: 'Migrar este canal a otra implementación',
    expression_1104: 'Subdominio',
    expression_1105: 'Dominio',
    expression_1106: 'Canal ID',
    expression_1107: '¡Comenzó la migración! Le enviaremos una notificación cuando terminemos.',
    expression_1108: 'Esta acción es irreversible y eliminará los tokens de la sesión actual de WhatsApp.',
    expression_1110: 'Ver conversación',
    expression_1111: '¡Usted tiene um nuevo mensaje!',
    expression_1112: 'te envió un nuevo mensaje!',
    expression_1113: 'Chat interno',
    expression_1114: 'Este boleto ya está siendo revisado o finalizado.',
    expression_1115: 'Atención: si desea importar números internacionales, solo importe una lista que contenga los números de ese país específico. No debe mezclar contactos de diferentes países en la misma lista.',
    expression_1116: 'Ningún',
    expression_1117: 'RANKING DE CANALES',
    expression_1118: 'RANKING DE DEPARTAMENTOS',
    expression_1119: 'RANKING DE ATENDENTES',
    expression_1120: 'Ingrese la URL aquí...',
    expression_1121: 'Campañas por Lista de Transmisión',
    expression_1122: 'Campañas por Estado',
    expression_1123: 'Informe al webhook que recibirá el estado de las campañas en este modo de entrega.',
    expression_1124: 'Filtros',
    expression_1125: 'a las',
    expression_1126: 'Sin mensaje',
    expression_1127: 'Descarga el archivo...',
    expression_1128: 'Cambiar el archivo',
    expression_1129: 'Esta funcionalidad está en fase de prueba.',
    expression_1130: 'No puede habilitar este módulo si la API está habilitada.',
    expression_1131: 'No puede habilitar este módulo si Chat-bot o Notifications están habilitados.',
    expression_1132: 'Para aprovechar al máximo la API, es posible que necesite la ayuda de un profesional calificado. Los módulos Chat-Bot y Notificaciones no pueden funcionar mientras este módulo está habilitado. Consulte nuestra documentación de API para obtener más información.',
    expression_1133: 'No se ha registrado ningún token.',
    expression_1134: 'El Contact debe haberse comunicado con el canal previamente. Además de los campos obligatorios, RD Station necesita la información de la “Empresa” para registrar el Contact. Por tanto, si el Contact tiene este campo rellenado en el CRM, le enviaremos esta información. De lo contrario, enviaremos su tipo de canal en lugar del campo "Empresa". Por ejemplo: “WhatsApp - ',
    expression_1135: 'Informe importante.',
    expression_1136: 'Como ya lo ha guiado el equipo de soporte del',
    expression_1137: 'debido al alto flujo de envíos masivos WhatsApp ha ido restringiendo cada vez más y bloqueando por este motivo.',
    expression_1138: 'Atentem-se para que não haja denúncias e bloqueios das suas contas devido al uso excesivo de esta funcionalidade.',
    expression_1139: 'Semper que possível, leia nossas dicas antes de fazer uma postagem para melhorar sua performance.',
    expression_1140: 'Em caso de dúvida, por favor, entre em contato com nosso suporte.',
    expression_1141: 'Ok, entendí!',
    expression_1142: 'Funcionalidade desactivada temporalmente.',
    expression_1143: 'Los paises',
    expression_1144: 'Estados',
    expression_1145: 'Ciudades',
    expression_1146: 'Corriendo',
    expression_1147: 'Dispositivos',
    expression_1148: 'Visitas',
    expression_1149: 'Informe de tráfico de campaña',
    expression_1150: 'Resumen de Campaña',
    expression_1151: 'Ver detalles',
    expression_1152: 'Nombre de campaña',
    expression_1153: 'Visitas Totales',
    expression_1154: 'por dia',
    expression_1155: 'Visitantes Únicos',
    expression_1156: 'Navegadores',
    expression_1157: 'Sistemas operacionales',
    expression_1158: 'Plomo eliminado con éxito!',
    expression_1159: '¿Está seguro de que desea eliminar este cliente potencial?',
    expression_1160: 'Delete Contact',
    expression_1161: 'Conexión con Telegram',
    expression_1162: 'Escanee el código QR para conectar su cuenta de WhatsApp',
    expression_1163: '1) Abre WhatsApp en tu móvil.',
    expression_1164: '2) Acceso',
    expression_1165: '"Más opciones" o "Configuración" y seleccione "Dispositivos conectados".',
    expression_1166: '3) Apunte su teléfono a esta pantalla para capturar el código.',
    expression_1167: 'Enviar código por SMS',
    expression_1168: 'Confirmar número de teléfono',
    expression_1169: 'Recibirá un SMS con el código de verificación en el siguiente número:',
    expression_1170: 'Insira o código de verificação',
    expression_1171: 'Recibirás un código por SMS. Ingrese este código a continuación:',
    expression_1172: 'Configurando entorno...',
    expression_1173: '¡Tu código ha sido validado con éxito! Ahora, estamos preparando su entorno. Esto puede tomar unos momentos.',
    expression_1174: '¡Tu cuenta está conectada!',
    expression_1175: '¡Felicidades! Ahora puedes comunicarte vía Telegram dentro de nuestro CRM.',
    expression_1176: 'Hemos perdido la conexión con tu cuenta de Telegram.',
    expression_1177: 'Si persiste, póngase en contacto con nuestro soporte.',
    expression_1178: 'Conexão Telegram',
    expression_1179: 'Monitoreo de tráfico',
    expression_1180: 'Habilite essa funcionalidade para gerar um link encurtado y adicionar códigos de rastreio à su campanha.',
    expression_1181: 'O monitoramento só está disponible para campanhas contendo arquivos. Adicione um arquivo no card anterior: Conteúdo da Campanha',
    expression_1182: 'Insira um arquivo',
    expression_1183: 'Desactivar',
    expression_1184: 'Ativar',
    expression_1185: 'Título del enlace',
    expression_1186: 'Este título aparecerá junto a la miniatura de la imagen en el enlace compartido.',
    expression_1187: 'Código de análisis de Google',
    expression_1188: 'ID de métrica de ejemplo: G-TWNTT9BWDL.',
    expression_1189: 'Código del administrador de etiquetas de Google',
    expression_1190: 'ID de métrica de ejemplo: G-TWNTT9BWDL.',
    expression_1191: 'Facebook Pixel Code',
    expression_1192: 'Ejemplo de ID de píxel: 1049737222095654.',
    expression_1193: 'Elija un canal de transmisión',
    expression_1194: '¡Necesitas crear un canal de difusión para generar tus campañas!',
    expression_1195: 'Inserta el enlace a tu canal de WhatsApp.',
    expression_1196: 'Conexión WhatsApp',
    expression_1197: 'Envíos HSM',
    expression_1198: '¡La lista de plantillas de HSM se sincronizó correctamente!',
    expression_1199: 'Sesión',
    expression_1200: 'Entregado',
    expression_1201: 'Leer',
    expression_1202: 'No enviado',
    expression_1203: 'Nombre de archivo',
    expression_1204: 'Espacio de texto insuficiente',
    expression_1205: 'No se pudo agregar la variable',
    expression_1206: 'porque no hay espacio de texto.',
    expression_1207: 'Vista previa de lo payload',
    expression_1208: 'Ejemplo',
    expression_1209: 'Informe de webhooks',
    expression_1210: 'Buscar webhooks',
    expression_1211: 'Registros de webhooks',
    expression_1212: 'Aún no se ha enviado ningún Webhook.',
    expression_1213: 'Comentarios oficiales de la API',
    expression_1214: 'Payload',
    expression_1215: 'Reenviar',
    expression_1216: '¡Mensaje reenviado!',
    expression_1217: 'Se ha realizado un nuevo envío a la API oficial.',
    expression_1218: 'lead(s) enviado(s)',
    expression_1219: 'No se puede verificar que el cliente potencial ya existe en el canal, vuelva a seleccionarlo.',
    expression_1220: 'Crear grupo de envío',
    expression_1221: 'Gestión de grupos de envío',
    expression_1222: 'Grupos',
    expression_1223: 'Todos los grupos',
    expression_1224: 'Eliminar grupo',
    expression_1225: 'canales encontrados',
    expression_1226: 'Nuevo grupo',
    expression_1227: 'grupo seleccionado',
    expression_1228: 'Nombre del grupo',
    expression_1229: '¿Está seguro de que desea eliminar este grupo ?',
    expression_1230: 'Crea un grupo',
    expression_1231: 'Seleccione un grupo',
    expression_1232: 'Editar nombre del grupo',
    expression_1233: 'Volver a la selección de grupo',
    expression_1234: '¡Grupo creado con éxito!',
    expression_1235: '¡Grupo eliminado con éxito!',
    expression_1236: '¡Canal agregado exitosamente!',
    expression_1237: 'Los grupos de envío se utilizan para organizar pequeños grupos de canales con nombre para facilitar los destinatarios de sus campañas.',
    expression_1238: 'Administre esta herramienta y disfrute de sus características.',
    expression_1239: '¿Qué es un grupo de envío?',
    expression_1240: 'Los Canales Oficiales no se pueden incluir en grupos!!',
    expression_1241: 'Creado',
    expression_1242: '-> El ID de usuario n.º {id} no tiene acceso a este canal. Por favor, consulte con soporte!',
    expression_1243: 'No es posible desconectarse del canal sin borrar primero a la operadora.',
    expression_1244: 'Sostener',
    expression_1245: 'La plantilla ha sido enviada para su eliminación, espere la respuesta de Meta. Si la eliminación no se produce de inmediato, sincronice haciendo clic en el botón "Sincronizar plantillas".',
    expression_1246: 'Sincronizar plantillas',
    expression_1247: 'Ocultar otros idiomas',
    expression_1248: 'Ocultar o mostrar plantillas de idiomas que no sean del sistema',
    expression_1249: 'Ver otros idiomas',
    expression_1250: "Por favor, seleccione una hoja de tipo .csv, .xls ou .xlsx",
    expression_1251: "Informe de tráfico de chatbots",
    expression_1252: "Clics del mes actual",
    expression_1253: "Clics",
    expression_1254: "Bienvenido al informe de clics de tu chatbot",
    expression_1255: "Para ver las estadísticas, seleccione un canal",
    expression_1256: "Niveles de chatbots",
    expression_1257: "Ver nivel principal",
    expression_1258: "Estadísticas de clics del Chatbot",
    expression_1259: "El canal no tiene información de clic para ver",
    expression_1260: "Seleccione otro canal",
    expression_1261: "Informe",
    expression_1262: 'Haga clic en filtrar',
    expression_1263: "WhatsApp Web QR (no oficial)",
    expression_1264: "No se le permite cambiar.",
    expression_1265: 'Acerca de Whatsapp Web',
    expression_1266: 'Integración con WhatsApp Web no oficial.', /*Sem referência para seu contexto*/
    expression_1267: 'Desconectar',
    expression_1268: 'Sesión desconectada', /*Sem referência para seu contexto*/
    expression_1269: 'Conectado!',
    expression_1270: 'No se puede habilitar porque la "Meta API oficial" está habilitada.',
    expression_1271: 'No se puede habilitar porque "Código QR" está habilitado.',
    expression_1272: 'Abrir la agenda',
    expression_1273: 'Cerrar la agenda',
    expression_1274: 'No hay más filtros que el canal seleccionado para la búsqueda',
    expression_1275: 'Conectar',
    expression_1276: 'Desconectado!',
    expression_1277: 'Registra tu campaña o exporta informes',
    expression_1278: "Habilitar y configurar una integración en \"Canales\"",
    expression_1279: "Generar Secret",
    expression_1280: "Necesitas tener un token válido para integrarte",
    expression_1281: "Desconéctese de WhatsApp Business API para integrarse con WhatsApp",
    expression_1282: "Desconéctese de WhatsApp para integrarse con la API de WhatsApp Business",
    expression_1283: "Hubo un error al generar tu secreto",
    expression_1284: "Token y secreto generados exitosamente",
    expression_1285: "Seleccionar todos los canales",
    expression_1286: "Desmarcar todos los canales",
    expression_1288: "contenido del subtítulo",
    expression_1289: 'Continuar',
    expression_1290: 'Agentes en línea',
    expression_1291: 'Agentes',
    expression_1292: 'Conversaciones Completadas',
    expression_1293: 'Terminado',
    expression_1294: 'Conversaciones',
    expression_1295: 'Conversaciones inconclusas',
    expression_1296: 'Mensajes',
    expression_1297: 'Negocios atrasados',
    expression_1298: 'Atrasados',
    expression_1299: 'Ciclo de Ventas',
    expression_1300: 'Ciclo',
    expression_1301: 'Días',
    expression_1302: 'Volumen de Oportunidades',
    expression_1303: 'Volumen',
    expression_1304: 'Conversión de ventas (30 días)',
    expression_1305: 'Ganancias',
    expression_1306: "Métricas de interacción y compromiso de los usuarios",
    expression_1307: "Rendimiento de campañas y métricas de correo electrónico",
    expression_1308: "Informes de mensajes de servicio",
    expression_1309: "Net Promoter Score y satisfacción del cliente",
    expression_1310: "Métricas de rendimiento y productividad",
    expression_1311: "Estadísticas de envío y entrega de SMS",
    expression_1312: "Informes de llamadas y comunicación por voz",
    expression_1313: "Análisis de conversaciones e interacciones",
    expression_1314: "Monitoreo y análisis de webhooks",
    expression_1315: "Métricas de chatbots y autoservicio",
    expression_1316: "Análisis de oportunidades y conversiones",
    expression_1317: "Visualiza y analiza datos importantes para tomar decisiones estratégicas",
    expression_1318: "Potencializa tus Relaciones",
    expression_1319: "Accede al Bee CRM y transforma los datos en conexiones valiosas con tus clientes.",
    expression_1319_wl: "Accede al CRM y convierte datos en conexiones valiosas con tus clientes.",
    expression_1320: "Gestión Inteligente",
    expression_1321: "Centraliza contactos, automatiza tareas y sigue oportunidades en tiempo real.",
    expression_1322: "Productividad Acelerada",
    expression_1323: "Reduce el tiempo en tareas manuales y concéntrate en lo que realmente importa: tus clientes.",
    expression_1324: "Seguridad Garantizada",
    expression_1325: "Tus datos protegidos con encriptación avanzada y controles de acceso personalizados.",
    expression_1326: "Integración Completa",
    expression_1327: "Conéctate con tus herramientas favoritas y unifica tus procesos de negocio.",
    expression_1328: "Al continuar, aceptas los",
    expression_1328_wl: "Al continuar, aceptas nuestros Términos de Servicio.",
    expression_1329: "Términos de Servicio",
    expression_1330: "de Bee CRM.",
    expression_1331: "¡Bienvenido de nuevo!",
    expression_1332: "Inicia sesión con tus credenciales para acceder a tu cuenta",
    expression_1333: "Tu correo electrónico corporativo",
    expression_1334: "Tu contraseña",
    expression_1335: "Recuperar Acceso",
    expression_1336: "Recupere su acceso",
    expression_1337: "Restablezca su contraseña de manera rápida y segura para volver a gestionar sus relaciones.",
    expression_1338: "Seguridad Avanzada",
    expression_1339: "Proceso protegido por encriptación y verificación en múltiples etapas.",
    expression_1340: "Proceso Rápido",
    expression_1341: "Recupere su acceso en pocos minutos y vuelva a usar el sistema.",
    expression_1342: "Confirmación Segura",
    expression_1343: "Reciba instrucciones detalladas directamente en su correo electrónico registrado.",
    expression_1344: "Nueva Credencial",
    expression_1345: "Cree una nueva contraseña fuerte para proteger sus datos e información.",
    expression_1346: "Tu contraseña ha sido cambiada con éxito. Ahora puedes iniciar sesión con tu nueva contraseña.",
    expression_1347: "Visualice notificaciones de informes o actualizaciones del sistema.",
    expression_1348: "Mensajes y Notificaciones",
    expression_1349: "Gestión de cuentas",
    expression_1350: "En desarrollo",
    expression_1351: "Marcar todas como leídas",
    expression_1352: "Marcar todas como no leídas",
     /*TRADUCOES Channel_Flow*/
    /*TRADUCOES CompanyInformation*/
    expression_1353: "Nombre de la Empresa",
expression_1354: "Equipos añadidos",
expression_1355: "Eliminar equipo",
expression_1356: "Sector de actividad",
expression_1357: "Seleccione el sector de su empresa",
expression_1358: "Complete la información básica de su empresa para iniciar el registro del",
expression_1359: "Estos datos se utilizarán para configurar e identificar su canal.",
expression_1360: "Ingrese el nombre del equipo.",
expression_1361: "Este equipo ya ha sido añadido.",
expression_1362: "Ingrese el nombre de la empresa.",

    /*TRADUCOES TITLES*/
expression_1363: "Seleccione el Canal",
expression_1364: "Información de la Empresa",
expression_1365: "Registro de Usuarios",
expression_1366: "Activación del Canal",
expression_1367: "Confirmación",
expression_1368: "Siguiente",
/*TRADUCOES Avisos*/
expression_1369: "Seleccione un canal para continuar.",
expression_1370: "¡El nombre de la empresa es obligatorio!",
expression_1371: "Agregue al menos un equipo antes de continuar.",
expression_1372: "Agregue al menos un usuario.",

expression_1373: "🎉 ¡Registro Completado! 🎉",
expression_1374: "¡Su registro se ha completado con éxito!",
expression_1375: "Cerrar",

/*TRADUCOES USERS*/
expression_1376: "Ahora, vamos a registrar al usuario que tendrá acceso al canal. Defina el nombre, correo electrónico, contraseña y función.",
expression_1377: "Ingrese el correo electrónico del usuario",
expression_1378: "Ingrese el nombre completo del usuario",
expression_1379: "Los administradores no pueden estar vinculados a equipos.",
expression_1380: "Seleccione el equipo",
expression_1381: "Usuarios añadidos:",
expression_1382: "Este correo electrónico ya ha sido añadido.",
expression_1383: "Este correo electrónico ya existe en el sistema.",
expression_1384: "Error al verificar el correo electrónico.",
expression_1385: "Complete todos los campos obligatorios.",
expression_1386: "Correo electrónico no válido.",
expression_1387: "El formato del correo electrónico es inválido.",
expression_1388: "añadido con éxito!",
expression_1389: "Usuario eliminado con éxito.",
expression_1390: "Responsable de enviar, recibir mensajes y gestionar su negocio.",
expression_1391: "Acceso total para gestionar configuraciones, usuarios y mensajes.",
expression_1392: "Puede gestionar mensajes y configuraciones, pero no usuarios.",
expression_1393: "Eliminar usuario",
expression_1394: "Usuario",


/*TRADUCOES CHANNEL - Activation*/
expression_1395: "Haz clic abajo para activar tu canal ahora mismo. Luego, haz clic en \"Activar Canal\".",
expression_1396: "¡Canal activado con éxito!",
expression_1397: "Algo salió mal durante la activación. Inténtalo de nuevo.",
expression_1398: "Error al activar el canal:",
expression_1399: "Error inesperado al activar el canal.",
expression_1400: "Activar Canal",
expression_1401: "Activando...",
expression_1402: "Seleccione un canal de comunicación",

/*Ajuda*/
expression_1403: "Centro de Ayuda",
expression_1404: "Soporte Bee",
expression_1405: "Blog de Bee",
expression_1406: "Política de privacidad",
expression_1407: "Seleccione una etiqueta para agregar",
expression_1408: "Actualizar",
expression_1409: "Ver menos",
expression_1410: "Campos Personalizados",
expression_1411: "Ningún campo personalizado disponible",
expression_1412: "Ingrese el valor para",
expression_1413: "Oportunidad",
expression_1414: "Value",
expression_1415: "Primero seleccione un canal",
expression_1416: "Seleccione un canal para ver los campos personalizados",
expression_1417: "No hay campos personalizados disponibles para este canal",
expression_1418: "Agregar campo",
expression_1419: "Todos los campos",
expression_1420: "Campos seleccionados",
expression_1421: "Ningún campo seleccionado",
expression_1422: "Filtros Generales",
expression_1430: "¡Nombre actualizado!",
expression_1431: "No se pudo actualizar el nombre",
expression_1432: "¡Newsletter actualizada!",
expression_1433: "No se pudo actualizar la suscripción",
expression_1434: "Ninguna oportunidad encontrada",
expression_1435: "Buscando leads...",
expression_1436: "No se encontraron leads con los filtros actuales.",
expression_1437: "Confirmo que hemos obtenido el consentimiento adecuado para enviar SMS, correos electrónicos u otros tipos de mensajes a los contactos que están siendo creados o importados, en conformidad con las leyes y regulaciones aplicables.",
expression_1438: "Necesitas aceptar los términos para continuar.",
expression_1439: 'Nombre del Campo',
expression_1440: 'Tipo de Campo',
expression_1441: 'Nuevo Campo',
expression_1442: 'Acciones',
expression_1443: 'Activos',
expression_1444: 'Archivados',
expression_1445: 'Seleccionar Canal',
expression_1446: 'Seleccione un canal para ver los campos personalizados',
expression_1447: '¿Confirma la eliminación del atributo y su información?',
expression_1448: 'Esta acción no se puede deshacer y todos los datos asociados se perderán.',
expression_1449: 'Eliminar Atributo',
expression_1450: 'Administre sus preferencias y personalizaciones',
expression_1451: 'Editar Campo',
expression_1452: 'Campo creado con éxito',
expression_1453: 'Campo actualizado con éxito',
expression_1454: 'Opciones',
expression_1455: 'Agregar Opción',
expression_1456: 'Crear Campo',
expression_1457: 'No se encontró campo para',
expression_1458: 'No se creó ningún campo personalizado para este canal',
expression_1459: 'Crear el Primer Campo',
expression_1460: 'Nombre del campo',
expression_1461: 'Campo archivado con éxito',
expression_1462: 'Campo desarchivado con éxito',
expression_1463: 'Ya existe un campo con este nombre',
expression_1464: 'Agregue al menos una opción para el campo de selección',
expression_1465: 'El nombre del campo es obligatorio',
expression_1466: 'El nombre del campo debe tener como máximo 30 caracteres',
expression_1467: 'Seleccione un canal antes de guardar el campo',
expression_1468: 'Campo',
expression_1469: 'eliminado con éxito',
expression_1470: 'Limpiar todo',
expression_1471: 'Últimas negociaciones',
expression_1472: 'Presupuesto',
expression_1473: "Protocolo copiado:",
expression_1474: "¡Copiado!",
expression_1475: "Agenda",
// expression_1476: "¡Hola! Su sesión de conversación en WhatsApp ha finalizado. Para iniciar una nueva conversación, seleccione un modelo de mensaje haciendo clic",
// expression_1477: "aqui",
expression_1478: "Nueva Oportunidad",
expression_1479: "Nueva Propuesta",
expression_1480: "Ninguna compra registrada",
expression_1481:  "Buscar",
expression_1482: "Escriba algo para buscar contactos",
expression_1483: "Utilice el campo de búsqueda arriba.",
expression_1484: "No se encontraron contactos",
expression_1485: "Intente usar términos diferentes o verifique si el contacto está registrado en el sistema.",
expression_1486: "Suscrito",
expression_1487: "Cancelar suscripción",
expression_1488: "No suscrito",
expression_1489: "(Suscribirse)",
expression_1490: "Conversaciones y atención",
expression_1491: "Plantillas HSM",
expression_1492: "Medios",
expression_1493: "Ocultar detalles del lead",
expression_1494: "Mostrar detalles del lead",
expression_1495: "Cargando los mensajes. Por favor, espere.",
expression_1496: "Seleccionar canal",
expression_1497: "Elija las etiquetas para segmentar su audiencia",
expression_1498: "Seleccione las etiquetas...",
expression_1499: "Seleccionar mensaje modelo",
expression_1500: "Elegir mensaje modelo",
expression_1501: "Todas",
expression_1502: "Limpiar",
expression_1503: "de",
expression_1504: "seleccionadas",
expression_1505: "Complete la información personalizada",
expression_1506: "Variables del Sistema",
expression_1507: "Haga clic en una variable para insertarla en el texto",
expression_1508: "Opciones de envío",
expression_1509: "Seleccione una plantilla arriba.",
expression_1510: "Elija un archivo PDF",
expression_1511: "Elija un archivo JPG o PNG",
expression_1512: "Mensaje modelo",
expression_1513: "Hora",
expression_1514: "Horas recomendadas",
expression_1515: "Las publicaciones solo pueden compartirse entre 20 minutos y 29 días después de ser creadas.",
expression_1516: "Mejores horarios para el engagement",
expression_1517: "Basado en estudios de comportamiento del usuario",
expression_1518: "Ningún modelo encontrado para",
expression_1519: "Intente utilizar términos diferentes o verifique la ortografía.",
expression_1520: "Buscando modelo",
divisor: '_________________________________________________________________________________________',
    tags: 'Tags',
    departments: 'Departamentos',
    histories: 'Mensajes (API)',
    interests: 'Intereses',
    motives: 'Calificación de Protocolo',
    operators: 'Operador',
    replies: 'Respuestas Rápidas',
    sources: '',
    users: 'Usuarios',
    widget: 'Widget'
  },
  getters: {
    getTranslationEs: () => (key) => {
      return key.es
    },
  },
}
export default es;
